import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setBreadcrumbs, removeBreadcrumb, removeBreadcrumbs } from './actions';
import { parseSet, parseReset } from './parsers';

const breadcrumbsSelector = (state) => state.breadcrumbs.activeBreadcrumbs;

// TODO refactor
export const useBreadcrumbs = () => {
  const breadcrumbs = useSelect(breadcrumbsSelector);
  const setAction = useAction(setBreadcrumbs);
  const removeAction = useAction(removeBreadcrumb);
  const removeOnMatchAction = useAction(removeBreadcrumbs);
  return {
    breadcrumbs,
    setBreadcrumbs: (breadcrumb) => {
      return setAction(parseSet(breadcrumbs, breadcrumb));
    },
    resetBreadcrumbs: () => setAction(parseSet(breadcrumbs)),
    setInitBreadcrumbs: (isTechnicalUser = false) =>
      setAction(parseReset(isTechnicalUser)),
    removeBreadcrumb: (breadcrumb) => removeAction(breadcrumb),
    removeBreadcrumbs: (deletePattern) => removeOnMatchAction(deletePattern),
  };
};
